<script lang="ts">
  import MaskedInput from 'Components/Common/Form/MaskedInput.svelte';
  import {dollarMaskOption} from 'Utility/formatters/mask';

  export let maskedValue: string;
  export let showError: boolean = false;
  export let placeholder: string = '';
  export let name: string = '';
  export let newLayout: boolean = false;
  export let label: string = '';
  export let helpText: string = '';
  export let moneyMask = dollarMaskOption();
</script>

<MaskedInput
  unmask={true}
  type="text"
  iMaskOptions={moneyMask}
  containerClass="center"
  class={showError ? 'form-control field-danger' : 'form-control'}
  {name}
  {placeholder}
  {newLayout}
  {label}
  {helpText}
  on:input
  on:blur
  bind:value={maskedValue}
/>
